import React, {Fragment} from 'react';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import {SectionPaddingHalf, SectionPartnershipApplicationBg} from '@/section';
import FormsHandler from '@/formshandler/index';
import HubspotForm from '@/ui/hubspotform';
import {validateEmailOnChange} from '@/formshandler/custom-email-validation';
import FormWrapper from '@/forms/form-wrapper';
import withNomenuLayout from 'layouts/nomenu';
import {H1Neutral50, PNeutral50} from '@/typography';
import {withMarginBottomLg, withMarginBottomMd} from '@/hocs/withSpacing';
import GoBackLink from '@/ui/go-back-link';
import Copyright from '@/footer/copyright';

const seoMetas = {
  title: "Apply to join Workable's partnership program | Developer partners",
  description:
    "Submit your application to join the technology partner program, get access to our API, or become a referral partner. Connect your product with Workable's HR & recruiting platform.",
  canonical: 'https://www.workable.com/partnership-program/apply'
};

const MarginedH1Neutral50 = withMarginBottomMd(H1Neutral50);
const MarginBottomLg = withMarginBottomLg('div');

const PartnershipProgramPage = props => (
  <>
    <SectionPartnershipApplicationBg>
      <Container>
        <Grid fluid>
          <Row center="sm">
            <Col xs={12} lg={8}>
              <MarginedH1Neutral50>Apply to join Workable’s partnership program</MarginedH1Neutral50>
              <PNeutral50>
                Submit an application to join our technology partner program, get access to our API,
                or become a referral partner.
              </PNeutral50>
            </Col>
          </Row>
        </Grid>
      </Container>

      <SectionPaddingHalf>
        <Container>
          <Grid>
            <Row start="md">
              <Col xs={12} md={8} mdOffset={2}>
                <MarginBottomLg>
                  <GoBackLink className="cta-default-xs-light-reverse" label="Go back" />
                </MarginBottomLg>
              </Col>
            </Row>
            <Row center="xs">
              <Col xs={12} md={8}>
                <FormWrapper className="hs-form partner-form form-animated">
                  <HubspotForm
                    portalId={process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID}
                    formId={process.env.NEXT_PUBLIC_PARTNERSHIP_FORM_ID}
                    css=""
                    onFormError={FormsHandler.handleFormError}
                    onFormReady={() => {
                      FormsHandler.handleFormReady();

                      FormsHandler.handleInputFocus(process.env.NEXT_PUBLIC_PARTNERSHIP_FORM_ID);

                      FormsHandler.populateGCLIDValue();

                      FormsHandler.populateMetroValue();

                      validateEmailOnChange(process.env.NEXT_PUBLIC_PARTNERSHIP_FORM_ID);
                    }}
                    onFormSubmitted={() => {
                      if (window.dataLayer) {
                        window.dataLayer.push({
                          event: 'Event',
                          eventCategory: 'Form',
                          eventAction: 'Submitted',
                          eventLabel: 'Partner Program Form'
                        });
                      }
                    }}
                  />
                </FormWrapper>
              </Col>
            </Row>
          </Grid>
        </Container>
      </SectionPaddingHalf>
    </SectionPartnershipApplicationBg>
    <Copyright linkColor="underlined" variant="orange50" />
  </>
);

export default withNomenuLayout(PartnershipProgramPage, {...seoMetas, ...{lightHeader: true}});

export {getSharedPageStaticProps as getStaticProps} from 'helpers/sharedPageStaticProps';
